/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import clsx from 'clsx'
import { KTIcon, toAbsoluteUrl } from '../../../helpers'
import {
  HeaderNotificationsMenu,
  HeaderUserMenu,
  QuickLinks,
  Search,
} from '../../../partials'
import {LanguagesNavbar} from '../../../partials/layout/header-menus/Languages'
import { useAuth } from '../../../../app/modules/auth'
import { useUserProfile } from '../../../../app/hooks/useUserProfile'
import Clock from './Clock'
import { axiosClientAuth } from '../../../../app/utils/axiosClient'
import { useLocation, useNavigate } from 'react-router-dom'
import { MenuComponent } from '../../../assets/ts/components'

const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
  toolbarButtonHeightClass = 'btn-active-light-primary btn-custom w-30px h-30px w-md-40px h-md-40p',
  toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px',
  toolbarButtonIconSizeClass = 'fs-1'
export interface NotificationData {
  id?: number
  title: string
  message: string
  created_at: string
  event_type?: string
  resource_type?: string
  resource_id?: string
  actor?: string
  meta?: any
}
const Topbar: FC = () => {
  const { auth, currentUser } = useAuth()
  const { data: profile } = useUserProfile()
  const [notificationData, setNotificationData] = useState<NotificationData[]>([]);
  const nav = useNavigate();
  const location = useLocation()
  const user = profile || currentUser || auth?.user
  const displayName = user?.name || user?.username || 'User'
  const isAuthenticated = !!auth?.access_token

  const fetchNotifications = () => {
    axiosClientAuth.get(`/notifications/`)
      .then((res) => {
        setNotificationData(res.data?.data?.results || [])
      })
      .catch((error) => console.log(error))
  }
  useEffect(() => {
    fetchNotifications()
  }, [])

  useEffect(() => {
    const reinitTimer = setTimeout(() => {
      MenuComponent.reinitialization()
    }, 100)

    return () => clearTimeout(reinitTimer)
  }, [location.pathname, currentUser?.id, notificationData.length])

  const handleNotificationNavigate = async (path: string) => {
    const route = navigateTo(path)
    nav(route)
  }

  return (
    <div className='d-flex align-items-stretch flex-shrink-0'>
      <div className='topbar d-flex align-items-stretch flex-shrink-0'>
        {/* Search */}
        {/* <div className={clsx('d-flex align-items-stretch', toolbarButtonMarginClass)}>
          <Search />
        </div> */}
        {/* Activities */}
        {/* <div className={clsx('d-flex align-items-center ', toolbarButtonMarginClass)}>
          <div
            className={clsx(
              'btn btn-icon btn-active-light-primary btn-custom',
              toolbarButtonHeightClass
            )}
            id='kt_activities_toggle'
          >
            <KTIcon iconName='chart-simple' className={toolbarButtonIconSizeClass} />
          </div>
        </div> */}



        {/* CHAT */}
        <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)} onClick={fetchNotifications}>
          <div
            className={clsx(
              'btn btn-icon btn-active-light-primary btn-custom position-relative',
              toolbarButtonHeightClass
            )}
            data-kt-menu-trigger='click'
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='bottom'
          // id='kt_drawer_chat_toggle'
          >
            <KTIcon iconName='notification' className={toolbarButtonIconSizeClass} />

            {notificationData.length > 0 && <span className='badge badge-circle bg-warning text-black h-8px w-8px position-absolute translate-middle top-25 start-75 animation-blink'></span>}
          </div>
          <HeaderNotificationsMenu
            notificationData={notificationData}
            handleNotificationNavigate={handleNotificationNavigate} />
        </div>

        {/* Quick links */}
        {/* <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
          <div
            className={clsx(
              'btn btn-icon btn-active-light-primary btn-custom',
              toolbarButtonHeightClass
            )}
            data-kt-menu-trigger='click'
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='bottom'
          >
            <KTIcon iconName='element-11' className={toolbarButtonIconSizeClass} />
          </div>
          <QuickLinks />
        </div> */}

        {/* begin::Language switcher */}
        <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
          <LanguagesNavbar />
        </div>
        {/* end::Language switcher */}

        <div className='d-flex gap-4'>

          <Clock />
        </div>
        {/* begin::User */}
        <div
          className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
          id='kt_header_user_menu_toggle'
        >
          {/* begin::Toggle */}
          {
            isAuthenticated &&
            <div
              className={clsx('cursor-pointer symbol', toolbarUserAvatarHeightClass)}
              data-kt-menu-trigger='click'
              data-kt-menu-attach='parent'
              data-kt-menu-placement='bottom-end'
              data-kt-menu-flip='bottom'
            >
              <div
                className='d-flex align-items-center justify-content-center symbol symbol-100px symbol-lg-160px symbol-fixed position-relative ms-2'
                style={{
                  height: '100%',
                  width: '38px',
                  backgroundColor: '#E8912D',
                  fontSize: '22px',
                }}
              >
                {displayName?.substr(0, 1)?.toUpperCase()}
              </div>
            </div>
          }
          <HeaderUserMenu />
          {/* end::Toggle */}
        </div>
        {/* end::User */}
      </div>
    </div>
  )
}

export { Topbar }

const navigateTo = (notificationType: string) => {
  switch (true) {
    case notificationType.includes('route'):
      return 'hops'
    case notificationType.includes('ip'):
      return 'dashboard'
    default:
      return 'dashboard';
  }
}
